import {RWSService} from '@rws-framework/client';

class TimeFormatService extends RWSService {
  shortMonth(date: string): string {
    //Nov 16
    const newDate = new Date(date);

    // Check if the date is valid
    if (isNaN(newDate.getTime())) {
      throw new Error('Invalid date string');
    };

    const dateFormatOptions: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat('en-US', dateFormatOptions).format(newDate);
    return formattedDate;
  };

  longDateTime(timestamp: string, comma: boolean = false): string {
    //May 12, 2024 08:23AM

    const date = new Date(timestamp);

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

    const month = monthNames[date.getMonth()];
    const weekday = weekdayNames[date.getDay()]
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedDate = `${month} ${day} ${year} ${hours}:${minutes} ${ampm}`;
    if (comma) {
      const timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g
      const timezoneClip = /[^-+\dA-Z]/g
      const Z = (String(date).match(timezone) || [""]).pop().replace(timezoneClip, "")
      return `${weekday}, ${month.substr(0, 3)} ${day}, ${year} ${hours}:${minutes} ${ampm} ${Z}`
    }
    return formattedDate;
  }

  compareDates(timestamp: string):boolean {
    const today = new Date().getTime();
    const date = new Date(timestamp).getTime();
    return date > today;
  }
  
  longDateTimeDash(timestamp: string): string {
    //February 7, 2024 - 9:08 AM

    const date = new Date(timestamp);

    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedDate = `${month} ${day}, ${year} - ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  }
}

export default TimeFormatService.getSingleton();

export {TimeFormatService as TimeFormatServiceInstance}
